<!-- <mat-card class="fd-business-data-detail__card-container"> -->
<div class="fd-business-data-detail__card-container width35" *ngIf="data">
  <table mat-table [dataSource]="dataSource" class="fd-table">
    <!-- ID Column -->

    <ng-container matColumnDef="transaction" class="fd-table__cell">
      <th mat-header-cell *matHeaderCellDef class="fd-table__header">Fator</th>
      <td mat-cell *matCellDef="let rowElement">{{ rowElement.transaction }}</td>
    </ng-container>

    <ng-container matColumnDef="suggestedFactorFee" class="fd-table__cell">
      <th mat-header-cell *matHeaderCellDef class="fd-table__header">Taxa</th>
      <td mat-cell *matCellDef="let rowElement">{{ rowElement.suggestedFactorFee | percent }}</td>
    </ng-container>

    <!-- Color Column -->

    <tr mat-header-row class="fd-table__header-row" *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row class="fd-table__row" *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</div>
<!-- </mat-card> -->
